import React, { Component } from 'react'
import { useSelector } from 'react-redux'
import ReactDOM from 'react-dom'
import Route from 'route-parser'
import cx from 'classnames'
import getUrl from 'front-end-core/core/url'
import { getBaseURI } from 'front-end-core/helpers/document'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import { URL_DATA } from 'constants/urls'
import ItemActionsContainer from 'redux/containers/pages/precedentscontent/ItemActionsContainer'
import selectIsIE from 'redux/selectors/selectIsIE'
import selectAolName from 'redux/selectors/selectAolName'
import Icon from 'components/shared/Icon'
import TealToolTip from 'components/TealToolTip'

const dataRoute = (props) => getBaseURI() + new Route(URL_DATA).reverse(props)

const portal = document.createElement('div')
document.body.appendChild(portal)

const DragHandle = ({ isDraggable, provided }) => (
  <div
    className={cx('flt-l mr6 h-100', { 'drag-handle': true, draggable: isDraggable })}
    {...provided.dragHandleProps}
  >
    <Icon className='w6 vm' name='icon-file-document' />
  </div>
)

export const Description = ({ title, name, description, children, provided, draggable: isDraggable }) => {
  const isIE = useSelector(selectIsIE)

  // Exclude description if empty without tags: eg. <p><br /><p>
  const checkedDescription = description.replace(/(<([^>]+)>)/ig, '').length ? description : null
  return (
    <div className='pa6 pb5'>
      <div className='flex flex-wrap-reverse justify-between'>
        <div className='flex items-center'>
          <DragHandle provided={provided} isDraggable={isDraggable} />
          <span className='b' dangerouslySetInnerHTML={{ __html: title || name }} />
        </div>
        <div className={cx({ 'items-center-ie-fix': isIE })}>
          {/* Action Buttons */}
          {children}
        </div>
      </div>
      <div className='precedents-description normal ml8' dangerouslySetInnerHTML={{ __html: checkedDescription }} />
    </div>
  )
}

export const PrecedentDownloadButton = ({ isLogged, id, hiddenRef, setSignUpModalIsOpen }) => {
  const handleOnClick = () => {
    if (!isLogged) {
      setSignUpModalIsOpen(true)
    }
  }
  const aol = useSelector(selectAolName)
  const route = dataRoute({ aol, id })

  return (
    <TealToolTip title='Download'>
      <a
        className='pointer mh2 bg-inherit'
        onClick={handleOnClick}
        data-help-item='precedentsdownload'
        data-help-position='left'
        href={route}
        download='FromCounsel - Selected content'
        target='_blank'
        rel='noopener noreferrer'
        data-event-category='Download'
        data-event-action='Print'
        data-event-label={route}
      >
        <Icon className='w6 black' name='icon-download' />
      </a>
    </TealToolTip>
  )
}

/* eslint no-useless-constructor: 0 */
export default class Item extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    const {
      isLast,
      provided,
      snapshot,
      innerRef,
      isAdmin,
      view,
      sectionId,
      id,
      draggable: isDraggable,
      flavour
    } = this.props

    const result = snapshot.isDragging
      ? (
        <div className='bg-light-turquoise no-pointer-events ba2 b--dark-slate-blue' {...provided.draggableProps}>
          <Description {...this.props} />
        </div>
        )
      : (
        <li
          {...provided.draggableProps} ref={innerRef}
          className={cx({ isAdmin, isDraggable }, 'min-h-spacing-9 bg-white', { 'bb b--precedents-blue': !isLast })}
          id={getUrl(PRECEDENTS_CONTENT, { flavour, view, sectionId, expanded: id })}
          data-testid='documents-accordion-content'
        >
          <div className='relative'>
            <Description {...this.props}>
              <ItemActionsContainer {...{ ...this.props }} />
            </Description>
          </div>
        </li>
        )

    if (!snapshot.isDragging) {
      return result
    }
    return ReactDOM.createPortal(result, portal)
  }
}
